<script setup>
import { useRouter } from "vue-router";
import AppDataTable from "@/components/AppDataTable.vue";
import { useResourceList } from "@/composables/useResourceList";
import { fetchHomepageSections } from "./api";

const router = useRouter();
const columns = [
  { key: "title",   label: "Name",    sortable: true },
  { key: "enabled", label: "Enabled" },
  { key: "actions", label: "Actions", align: "end", width: "120px" },
];
const { rows, loading, error, load } =
  useResourceList({
    fetch: fetchHomepageSections,
    mapRow: (s) => ({ id: s._id, title: s.name ?? s.title ?? "—", enabled: s.isEnabled ? "Yes" : "No" }),
  });
</script>

<template>
  <section>
    <div class="d-flex align-center justify-space-between mb-4 gap-3 flex-wrap">
      <h1 class="text-h5">Homepage Sections</h1>
      <VBtn variant="tonal" @click="load">Refresh</VBtn>
    </div>
    <VAlert v-if="error" type="error" closable class="mb-4" @click:close="error = ''">{{ error }}</VAlert>
    <AppDataTable :columns="columns" :rows="rows" :loading="loading" row-key="id" searchable search-placeholder="Search sections…" empty-text="No sections found.">
      <template #cell-actions="{ row }">
        <VBtn size="small" variant="text" @click.stop="router.push({ name: 'homepage-sections-edit', params: { id: row.id } })">Edit</VBtn>
      </template>
    </AppDataTable>
  </section>
</template>
